import Phaser from "phaser";
import { Exit, Player } from "../objects";
import UI from "../UI";
import levelGoalKit from "./levelGoalKit";

class levelDarkKit extends levelGoalKit {
  async connectToScene(scene) {
    await super.connectToScene(scene);
    //  Enable lights and set a dark ambient color
    scene.lights.enable().setAmbientColor(0x000000);

    scene.children.getByName("layer_0").setPipeline("Light2D");
    scene.children.getByName("layer_1").setPipeline("Light2D");
    scene.children.getByName("layer_2").setPipeline("Light2D");
    scene.children.getByName("layer_1z2").setPipeline("Light2D");
    this.moveables.forEach(m => !m.isClass(Player) && m.alien?.active && m.alien?.setPipeline("Light2D"));
    Object.values(this.decorationElements).forEach(m => m.alien?.setPipeline("Light2D"));

    this.scene.events.on("player_moves", (nextPos) => {
      this.updateLight(nextPos);
    })

    if(this.unfinished) {
      // adds light on angel
      this.staticlight = scene.lights
        .addLight(
          UI.tileToScreen(this.exit.position.x),
          UI.tileToScreen(this.exit.position.y),
          1000
        )
        .setColor(0xe6c8c8)
        .setIntensity(1.5);
      scene.time.addEvent({
        delay: 100,
        callback: function () {
          if (!this.exit.block.alien.active && this.staticlight.intensity > 0) {
            this.staticlight.setIntensity(this.staticlight.intensity - 0.5);
          }
          Phaser.Geom.Ellipse.Random(this.exit.block.alien, this.staticlight);
        },
        callbackScope: this,
        repeat: -1,
      });
    }
  }

  onAddElement(el) {
    super.onAddElement(el)

    if (el.isClass(Exit)) {
      const layer = this.scene.children.getByName("layer_2");
      const map = layer.tilemap;

      this.exitEye = this.scene.add.sprite(48, 16, "spark").setOrigin(0.5, 0.5);
      this.exitEye.setTintFill(0xd25400);
      this.exitEye.setScale(layer.scaleX * 2, layer.scaleX * 4);
      this.exitEye.x = map.tileToWorldX(el.position.x - 0.5);
      this.exitEye.y = map.tileToWorldY(el.position.y - 0.4);
      this.exitEye.depth = 100;
      this.exitEye.alpha = 0;
    }
  }

  updateLight(nextPos) {
    if (!this.exit || !this.player.torch) return false;
    if (
      nextPos.x === this.exit.position.x - 3 &&
      nextPos.y === this.exit.position.y
    ) {
      this.player.light?.setRadius(500);
      this.player.light?.setIntensity(1.3);

      // remove alpha tween
      if (this.eyeAnimation) {
        this.exitEye.alpha = 0;
        this.eyeAnimation.remove();
      }
    } else if (
      nextPos.x === this.exit.position.x - 2 &&
      nextPos.y === this.exit.position.y
    ) {
      // this.player.light?.setIntensity(1.3)
      this.player.light?.setRadius(250);
      this.player.light?.setIntensity(0.8);

      // alpha tween from 0 to 0.5
      if (this.eyeAnimation) {
        this.eyeAnimation.remove();
      }
      this.exitEye.alpha = 0.1;
      this.eyeAnimation = this.scene.tweens.add({
        targets: this.exitEye,
        alpha: 0.2,
        duration: 100,
        yoyo: true,
        repeat: -1,
      });
    } else if (
      nextPos.x === this.exit.position.x - 1 &&
      nextPos.y === this.exit.position.y
    ) {
      // this.player.light?.setIntensity(1.3)
      this.player.light?.setIntensity(0.3);
      this.player.light?.setRadius(125);

      // alpha tween from 0.5 to 1
      if (this.eyeAnimation) {
        this.eyeAnimation.remove();
      }
      this.exitEye.alpha = 0.3;
      this.eyeAnimation = this.scene.tweens.add({
        targets: this.exitEye,
        alpha: 0.5,
        duration: 100,
        yoyo: true,
        repeat: -1,
      });
    } else if (
      nextPos.x === this.exit.position.x &&
      nextPos.y === this.exit.position.y
    ) {
      this.player.light?.setIntensity(0.1);
    } else if (this.player.light?.intensity !== 1.5) {
      this.player.light?.setIntensity(1.5);
      this.player.light?.setRadius(1000);
    }
  }
}
export default levelDarkKit;